module.exports = __webpack_public_path__ + "img/sdc_logo_portrait.e96acd12.png";